<template>
    <div v-loading="!finishGetList">
        <today-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :categoryData="categoryData" :sortData="filterSet.sort"
                           :paginationData="filterSet.page"></today-filter-link>
        <today-list-link :listLayout="listLayout" :todayData="List" :categoryData="categoryData"
                         :paginationData="filterSet.page" :sortData="filterSet.sort"></today-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import PaginationLink from "@/components/today/PaginationLink";
import util from "@/mixins/util";
import TodayListLink from "@/components/today/TodayListLink";
import todayUtil from "@/components/today/todayUtil";
import TodayFilterLink from "@/components/today/TodayFilterLink";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";


const {filterConfig} = todayUtil;
export default {
    name: "TodayListComponent",
    mixins: [alertMixins, filterMixins, listMixins, todayUtil],
    components: {TodayFilterLink, TodayListLink, PaginationLink},
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
        }
    },
    props: {
        todayType: '',
        defaultFilter: {
            default: () => {
            }
        },
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
            getFunc: '',
            pageRow: '',
            getCategoryFunc: '',
            keyName: '',
            directUrl: '',
            directType: '',
            categoryData: {},

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        if (this.isGetFirst) {
            this.getList(true);
        } else {
            this.finishGetList = true;
        }
        EventBus.$on('deleteTodayData', this.runDeleteConfirm);
    },
    beforeDestroy() {
        EventBus.$off('deleteTodayData');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let config = this.returnTodayConfig(this.todayType);
            this.filterLayout = config.filterLayout;
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;
            this.pageRow = config.pageRow;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;

            this.keyName = config.keyName
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();

            let defaultParams = Object.assign({}, this.listApiParamSet, this.defaultFilter);
            let listOptions = {
                url: this.$api.$today[this.getFunc],
                defaultParams: defaultParams,
            }

            this.initList('api', listOptions);

            if (this.isCategory) {
                this.getCategory();
            }
        },

        getCategory() {
            let params = {};
            try {
                this.$api.$today[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.categoryData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$today[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDeleteConfirm(key) {
            this.openDeleteConfirm({
                confirm: (value) => {
                    this.runDelete(key, value);
                },
                cancel: () => {
                }
            })
        },

        runDelete(key, value) {
            EventBus.$emit('apiLoading', true);
            this.DeleteClass.runDelete(key, {mb_password: value,})
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.getList();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
